import { Swiper } from 'swiper/bundle'
import { initSwiperOnView } from '../lib/funnels/functions/v1/html/initSwiperOnView'
import { toggleSubMenu } from '../lib/funnels/functions/v1/html/toggleSubMenu'
import {
  articlesByCategory,
  articleTemplate,
} from '../lib/funnels/constants/resourcesByCategory'
import { fetchWithCache } from '../lib/funnels/functions/v1/html/fetchWithCache'
import { newsItemTemplate } from '../lib/funnels/functions/v1/html/newsItemTemplate'
// @ts-expect-error doesn't like import path idk
import Map from './includes/us-map.svg?raw'

import 'swiper/css/bundle'
import './styles/accordion.css'
import './styles/homepage.css'
import './styles/key-benefits.css'
import './styles/testimonial.css'
import './styles/consolidation-bullets.css'
import './styles/sticky-ad.css'
import './styles/news-carousel.css'

document.addEventListener('DOMContentLoaded', async function () {
  // @ts-ignore
  window.Swiper = Swiper
  document.dispatchEvent(new CustomEvent('swiperLoaded'))

  const accordionHeaders = document.querySelectorAll('.accordion-header')
  if (accordionHeaders) {
    accordionHeaders.forEach((title, idx) => {
      title.addEventListener('click', (event) =>
        toggleSubMenu(/** @type {HTMLElement} */ (event.currentTarget)),
      )
      if (idx === 0) {
        toggleSubMenu(/** @type {HTMLElement} */ (title))
      }
    })
  }

  /* debt management resources categories/articles */
  const resourcesHolder = document.getElementById('resourcesByCategory')
  if (resourcesHolder) {
    const resourceCategories = Object.keys(articlesByCategory)
    resourceCategories.map((resource) => {
      const resourceCategoryHolder = document.createElement('div')
      resourceCategoryHolder.setAttribute(
        'data-category',
        resource.toLowerCase().replace(/\s+/g, '-'),
      )
      resourceCategoryHolder.classList.add('hidden')

      const resourceArticleListHolder = document.createElement('div')
      resourceArticleListHolder.classList.add(
        'debt-management-resource-article-list',
      )

      if (resource === 'Areas We Serve') {
        resourceCategoryHolder.innerHTML = Map
      } else {
        // @ts-ignore
        const articles = articlesByCategory[resource] || []
        const isSingle = articles.length === 1
        // @ts-expect-error article type
        articles.forEach((article) => {
          const articleHTML = articleTemplate(article, isSingle)
          resourceArticleListHolder.insertAdjacentHTML('beforeend', articleHTML)
        })
        resourceCategoryHolder.appendChild(resourceArticleListHolder)
      }

      return resourcesHolder.append(resourceCategoryHolder)
    })
  }

  /* dmr tabs */
  const debtManagmentTabs = document.querySelectorAll('[data-trigger-for]')
  if (debtManagmentTabs) {
    /**
     * @param {KeyboardEvent | MouseEvent} event
     */
    const toggleDMRContent = (event) => {
      const target = /** @type {HTMLElement} */ (event.currentTarget)
      const articlesButton = document.querySelector(
        '.debt-management-resource-button',
      )
      const prevActiveHeader = document.querySelector(
        '.dmr-carousel__tile.active',
      )
      const displayCategory = target.getAttribute('data-trigger-for')

      if (prevActiveHeader) {
        prevActiveHeader.classList.remove('active')
      }
      if (target) {
        target.classList.add('active')
      }
      if (articlesButton && displayCategory) {
        articlesButton.setAttribute(
          'href',
          `https://www.turbodebt.com/search?q=${displayCategory.replace(/-/g, '+')}`,
        )
        const articleButtonText = articlesButton.querySelector('span')
        if (articleButtonText)
          articleButtonText.textContent = `${displayCategory.replace(/-/g, ' ')}`
      }

      document.querySelectorAll('[data-category]').forEach((category) => {
        category.classList.add('hidden')
        category.querySelectorAll('a').forEach((link) => {
          link.setAttribute('tabindex', '-1')
        })
      })
      document
        .querySelector(`[data-category="${displayCategory}"]`)
        ?.classList.remove('hidden')
      //set the tab indices for the visible dmr links
      const category = document.querySelector(
        `[data-category="${displayCategory}"]`,
      )
      category?.querySelectorAll('a').forEach((link) => {
        link.setAttribute('tabindex', '0')
      })
    }
    debtManagmentTabs.forEach((trigger) => {
      trigger.addEventListener('keydown', (event) => {
        if (event instanceof KeyboardEvent && event.key === 'Enter') {
          toggleDMRContent(event)
        }
      })

      trigger.addEventListener('click', (event) => {
        // ignore TS here as it's not typing event correctly to MouseEvent
        // @ts-ignore
        toggleDMRContent(event)
      })
    })

    debtManagmentTabs[0].dispatchEvent(new Event('click'))
  }

  /* recent news */
  const NEWS_API_URL =
    'https://blog.turbodevhub.com/api/posts?&sort=createdAt%3Adesc&fields[0]=title&fields[1]=tag&fields[2]=slug&fields[3]=excerpt&fields[4]=Category&fields[5]=secondSlug&populate[coverImage][fields][0]=url&populate[coverImage][fields][1]=alternativeText&pagination[start]=0&pagination[limit]=3'

  const newsEl = document.getElementById('recentNews')
  try {
    const newsData = await fetchWithCache(
      NEWS_API_URL,
      'newsDataCache',
      24 * 60 * 60,
    ) // 24 hrs

    const newsItems = newsData.data.map(
      (/** @type {{ attributes: NewsItem; }} */ newsItem) => {
        const newsItemData = /** @type {NewsItem} */ (newsItem.attributes)
        return newsItemTemplate(newsItemData)
      },
    )

    if (newsEl) {
      newsEl.innerHTML = newsItems.join('')
    }
  } catch (e) {
    console.error(e)
  }

  // carousels
  initSwiperOnView('.review-carousel', {
    pagination: { el: '.review-pagination', clickable: true },
    breakpoints: {
      1024: { slidesPerView: 2, spaceBetween: 32 },
      1200: { slidesPerView: 2, spaceBetween: 24 },
    },
  })

  initSwiperOnView('.dmr-carousel', {
    navigation: { nextEl: '.dmr-next', prevEl: '.dmr-prev' },
    breakpoints: {
      320: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 10 },
      768: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 10 },
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    on: {
      init: () => {
        const nodeArray = [
          // @ts-ignore
          // ignoring because it's a pain to cast this all the way down to an array of nodes when we know what it is
          ...document.querySelector('.dmr-carousel__wrapper').childNodes,
        ]
        nodeArray.forEach((node) =>
          node.querySelector('[data-trigger-for]').setAttribute('tabindex', -1),
        )
        const activeIndex = nodeArray.findIndex((node) =>
          node.classList?.contains('swiper-slide-active'),
        )
        nodeArray
          .slice(
            activeIndex,
            activeIndex + (document.body.clientWidth < 1288 ? 3 : 4),
          )
          .forEach((node) => {
            node.querySelector('[data-trigger-for]').setAttribute('tabindex', 0)
          })
      },
      transitionEnd: () => {
        /** @type {HTMLElement|null} */
        const theirPrevButton = document.querySelector('.dmr-next + .dmr-prev')
        const ourPrevButton = document.querySelectorAll(
          '.dmr-carousel__outer .dmr-prev',
        )[0]
        const clickDefaultPrevButton = () => {
          theirPrevButton?.click()
        }
        const nodeArray = [
          // @ts-ignore
          // ignoring because it's a pain to cast this all the way down to an array of nodes when we know what it is
          ...document.querySelector('.dmr-carousel__wrapper').childNodes,
        ]
        nodeArray.forEach((node) =>
          node.querySelector('[data-trigger-for]').setAttribute('tabindex', -1),
        )
        const activeIndex = nodeArray.findIndex((node) =>
          node.classList?.contains('swiper-slide-active'),
        )
        nodeArray
          .slice(
            activeIndex,
            activeIndex + (document.body.clientWidth < 1288 ? 3 : 4),
          )
          .forEach((node) => {
            node.querySelector('[data-trigger-for]').setAttribute('tabindex', 0)
          })

        //we need to manually move the prev button because it's after the next button??
        //run once
        if (document.querySelectorAll('.dmr-prev').length === 1) {
          // run this once
          document
            .querySelector('.dmr-next + .dmr-prev')
            ?.setAttribute('tabindex', '-1') //remove from tab order
          const prevButton = document
            .querySelector('.dmr-prev')
            ?.cloneNode(true)
          if (prevButton) {
            document.querySelector('.dmr-carousel__outer')?.prepend(prevButton)
          }
          document
            .querySelectorAll('.dmr-carousel__outer .dmr-prev')[0]
            ?.setAttribute('tabindex', '0') //add to tab order
          document
            .querySelectorAll('.dmr-carousel__outer .dmr-prev')[0]
            ?.addEventListener('click', () => {
              clickDefaultPrevButton()
            })
          document
            .querySelectorAll('.dmr-carousel__outer .dmr-prev')[0]
            ?.addEventListener('keypress', (event) => {
              if (event instanceof KeyboardEvent && event.key === 'Enter') {
                clickDefaultPrevButton()
              }
            })
          /** @type {HTMLElement|null} */
          const buttonToHide = document.querySelector('.dmr-next + .dmr-prev')
          if (buttonToHide) {
            buttonToHide.style.display = 'none'
          }
        }

        if (theirPrevButton && ourPrevButton) {
          if (theirPrevButton.classList.contains('swiper-button-disabled')) {
            ourPrevButton.classList.add('swiper-button-disabled')
            ourPrevButton.setAttribute('aria-disabled', 'true')
            ourPrevButton.setAttribute('tabindex', '-1')
          } else {
            ourPrevButton.classList.remove('swiper-button-disabled')
            ourPrevButton.setAttribute('aria-disabled', 'false')
            ourPrevButton.setAttribute('tabindex', '0')
          }
        }

        // focus on the first active slide so we don't have focus at slide -1
        /** @type {HTMLElement|null} */
        const activeSlide = document.querySelector(
          '.swiper-slide-active [data-trigger-for]',
        )
        if (activeSlide) {
          activeSlide.focus()
        }
      },
    },
  })

  initSwiperOnView('.how-it-works-carousel', {
    pagination: { el: '.how-it-works-pagination', clickable: true },
    breakpoints: {
      768: { slidesPerView: 2, spaceBetween: 20 },
      1400: { slidesPerView: 4, spaceBetween: 20 },
    },
    on: {
      // resize: (swiper) => {
      //   console.log('resize')
      // }
    },
  })

  initSwiperOnView('.turbodebt-news-carousel', {
    pagination: { el: '.turbodebt-news-pagination', clickable: true },
    breakpoints: {
      320: { slidesPerView: 1, spaceBetween: 20 },
      1024: { slidesPerView: 3, spaceBetween: 30 },
    },
    on: {
      init: () => {
        if (document.body.clientWidth < 1023) {
          const newsContainer = document.querySelector('.turbodebt-news')
          newsContainer
            ?.querySelectorAll('.swiper-slide:not(.swiper-slide-active)')
            .forEach((hiddenSlide) => {
              hiddenSlide.querySelector('a')?.setAttribute('tabindex', '-1')
              hiddenSlide
                .querySelector('a')
                ?.setAttribute('aria-disabled', 'true')
            })
        }
      },
      transitionEnd: () => {
        if (document.body.clientWidth < 1023) {
          const newsContainer = document.querySelector('.turbodebt-news')
          newsContainer
            ?.querySelector('.swiper-slide-active a')
            ?.setAttribute('tabindex', '0')
          newsContainer
            ?.querySelector('.swiper-slide-active a')
            ?.setAttribute('aria-disabled', 'false')
          newsContainer
            ?.querySelectorAll('.swiper-slide:not(.swiper-slide-active)')
            .forEach((hiddenSlide) => {
              hiddenSlide.querySelector('a')?.setAttribute('tabindex', '-1')
              hiddenSlide
                .querySelector('a')
                ?.setAttribute('aria-disabled', 'true')
            })
        }
      },
    },
  })
})
